<template>
  <section class="advise">
    <img class="advise__image" :src="etapasClaveImage" alt="Sala acogedora">

    <div class="advise__content">
      <div class="advise__header">
        <h2 class="wd-title"><span class="hl">Etapas clave</span> <br class="br-m">para tu proceso</h2>
        <p class="wd-body">
          Tu camino está dividido en etapas claras.<br class="br-d"><br class="br-t">
          Aquí puedes entender en cuál estás y qué sigue:
        </p>
      </div>

      <div class="advise__grid">
        <article v-for="item in items" :key="item.title" class="advise__card">
          <p class="advise__card-title">{{ item.title }}</p>
          <p class="wd-body">{{ item.description }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import etapasClaveImage from '../../../assets/bienvenida-desktop/etapas-clave.jpg'

const items = [
  { title: 'Auto financiamiento', description: 'Tu grupo aporta a un fondo común que permite que los integrantes obtengan su vivienda.' },
  { title: 'Cuota periódica', description: 'Tu pago incluye tu aportación y costos administrativos.' },
  { title: 'Factor de actualización', description: 'Permite que tu financiamiento mantenga su valor en el tiempo.' },
  { title: 'Tipos de adjudicación', description: 'Permite que tu financiamiento mantenga su valor en el tiempo.' },
]
</script>

<style scoped>
.advise { display: flex; align-items: stretch; gap: var(--ds-space-5); }
.advise__image {
  flex: 0 0 410px;
  width: 410px;
  object-fit: cover;
  border-radius: 24px;
}
.advise__content { display: flex; flex: 1 1 0; flex-direction: column; gap: var(--ds-space-6); min-width: 0; }
.advise__header { display: flex; flex-direction: column; gap: var(--ds-space-3); }
.advise__grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: var(--ds-space-4); }
.advise__card {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-3);
  padding: var(--ds-space-4);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border-radius: 8px;
}
.advise__card-title {
  margin: 0;
  color: var(--ds-secondary-main);
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
}

@media (max-width: 1024px) {
  .advise { flex-direction: column; gap: var(--ds-space-7); }
  .advise__image { flex: none; width: 100%; height: 462px; }
  .advise__content { flex: none; gap: var(--ds-space-7); }
}

@media (max-width: 599px) {
  .advise { gap: var(--ds-space-6); }
  .advise__content { gap: var(--ds-space-6); }
  .advise__grid { grid-template-columns: 1fr; gap: var(--ds-space-6); }
}
</style>
